import React from "react";
import type { PublicMetrics } from "../appTypes";

interface LoginPageProps {
  loadingAuth: boolean;
  authError: string;
  documentInput: string;
  setDocumentInput: (value: string) => void;
  onLoginDemo: () => void;
  onLoginGuest: () => void;
  onLoginByDocument: () => void;
  metrics: PublicMetrics;
  apiStatus: "checking" | "online" | "offline";
  databaseStatus: string;
}

const LoginPage: React.FC<LoginPageProps> = ({
  loadingAuth,
  authError,
  documentInput,
  setDocumentInput,
  onLoginGuest,
  onLoginByDocument,
}) => {
  return (
    <section className="login-page">
      <div className="login-layout">
        <article className="login-showcase">
          <img
            src="/img/samuca2-neon-soft.png"
            alt="Apresentacao visual da plataforma"
            className="login-showcase-image"
          />
          <div className="login-showcase-overlay" />

          <div className="login-showcase-content">
            <h1 className="login-showcase-title">
              Entre e siga para a plataforma.
            </h1>
            <p className="login-showcase-description">
              Acesso simples em uma unica tela.
            </p>
          </div>
        </article>

        <article className="login-auth-panel">
          <div className="login-auth-card">
            <div className="login-brand-lockup" aria-label="Blue Academy">
              <div className="login-brand-mark">B</div>
              <div className="login-brand-copy">
                <strong>Blue</strong>
                <span>Academy</span>
              </div>
            </div>

            <div className="login-auth-tabs" aria-hidden="true">
              <span className="login-auth-tab is-active">
                Acessar sua conta
              </span>
            </div>

            <div className="login-auth-form">
              <div className="login-auth-heading">
                <h2 className="login-auth-title">Entre na plataforma</h2>
                <p className="login-auth-description">
                  Use seu documento ou um acesso rapido.
                </p>
              </div>

              <label className="login-field-label" htmlFor="document-input">
                Documento
              </label>
              <input
                id="document-input"
                value={documentInput}
                onChange={(event) => setDocumentInput(event.target.value)}
                className="auth-input login-auth-input"
                placeholder="Digite CPF ou documento vinculado"
              />

              <button
                type="button"
                className="primary-button login-submit-button"
                disabled={loadingAuth || !documentInput.trim()}
                onClick={onLoginByDocument}
              >
                {loadingAuth ? "Entrando..." : "Entrar"}
              </button>

              {authError ? (
                <p className="auth-error-message" role="alert">
                  {authError}
                </p>
              ) : null}

              <div className="login-auth-separator">
                <span>ou entre rapido</span>
              </div>

              <div className="login-quick-actions">
                <button
                  type="button"
                  className="login-action-card"
                  onClick={onLoginGuest}
                  disabled={loadingAuth}
                >
                  <strong>Entrar como visitante</strong>
                  <p>Navegue sem cadastro.</p>
                </button>
              </div>
            </div>
          </div>
        </article>
      </div>
    </section>
  );
};

export default LoginPage;
